import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { ApiGetSuccessResponse } from '../models/common/api-get-success-response';
import { Layout } from '../models/entities/layout';

@Injectable({
  providedIn: 'root',
})
export class LayoutsService {
  constructor(private apiService: ApiService) {}

  findAll(): Observable<ApiGetSuccessResponse<Layout[]>> {
    return this.apiService.get('layouts');
  }
}
